import {Box, Typography} from '@mui/material';
import { PreOrderData } from "../../common/Interfaces";
import styles from './EventStatusData.module.scss';
import CustomChip from '../common/customChip/CustomChip';
import { useTranslation } from 'react-i18next';
import PreOrderStatus from '../preOrderStatus/PreOrderStatus';

interface Props {
    preOrder: PreOrderData;
}

export default function EventStatusData ({preOrder}: Props){
    const {t} = useTranslation();

    return (<Box className={styles.container}>
        <Box className={styles.container}>
                {preOrder.Event && (
                    <Typography className={styles.titleText}>
                        {preOrder.Event.Code}
                    </Typography>
                )}

                <Box className={styles.horizontalContainer}>
                    <PreOrderStatus preOrder={preOrder} />
                </Box>
            </Box>
        
    </Box>);
}